const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/history.ts';
import { useHistory } from 'react-router-dom';
import {
    PATH_APPOINTMENT,
    PATH_APPOINTMENT_BOOKING,
    PATH_APPOINTMENT_BOOKING_CONFIRMATION,
    PATH_APPOINTMENT_RESCHEDULE,
    PATH_APPOINTMENT_RESCHEDULE_CONFIRMATION,
    PATH_APPOINTMENT_SUBLIMD_FRAME,
    PATH_APPOINTMENTS,
    PATH_DASHBOARD,
    PATH_ECHECKIN,
    PATH_INVOICES,
    PATH_MEDIS,
    PATH_REPORTS,
} from 'App/defs/router';

type History<T = unknown> = ReturnType<typeof useHistory<unknown>>;

export const goToDashboard = (history: History) => {
    history.push(PATH_DASHBOARD);
};

export const goToECheckin = (history: History) => {
    history.push(PATH_ECHECKIN);
};

export const goToAppointments = (history: History) => {
    history.push(PATH_APPOINTMENTS);
};

export const goToAppointmentBooking = (history: History) => {
    history.push(PATH_APPOINTMENT_BOOKING);
};

export const goToAppointmentBookingConfirmation = (history: History, terminNumber: string) => {
    history.push(PATH_APPOINTMENT_BOOKING_CONFIRMATION.replace(':termnr', terminNumber));
};

export const goToAppointmentReschedule = (history: History, terminNumber: string) => {
    history.push(PATH_APPOINTMENT_RESCHEDULE.replace(':termnr', terminNumber));
};

export const goToAppointmentRescheduleConfirmation = (history: History, terminNumber: string) => {
    history.push(PATH_APPOINTMENT_RESCHEDULE_CONFIRMATION.replace(':termnr', terminNumber));
};
export const goToSublimdIFrame = (history: History, termNr: string) => {
    history.push(PATH_APPOINTMENT_SUBLIMD_FRAME.replace(':termnr', termNr));
};

export const goToAppointment = (history: History, terminNumber: string) => {
    history.push(PATH_APPOINTMENT.replace(':termnr', terminNumber));
};

export const goToMedis = (history: History) => {
    history.push(PATH_MEDIS);
};

export const goToReports = (history: History) => {
    history.push(PATH_REPORTS);
};

export const goToInvoices = (history: History) => {
    history.push(PATH_INVOICES);
};
